import { IconButton, XCloseIcon } from "@minervaproject/fds";
import ReactModal from "react-modal";

import { LongFormPollResponse } from "./long_form_poll_responses";

import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { useIsMobile } from "hooks/use_is_mobile";
import { useUserProfileProperties } from "hooks/use_user_properties";
import { hideFeaturedPollResponse } from "shared/reducers/classroom";
import { FeaturedPollResponseType } from "shared/types";
import { classroomSelectors } from "store";

function FeaturedPollResponseModal({
  featuredPollResponse,
  canControlClassroom,
  containerId,
  containerHeight,
  containerWidth,
}: {
  featuredPollResponse: FeaturedPollResponseType;
  canControlClassroom: boolean;
  containerId: string;
  containerHeight: number;
  containerWidth: number;
}) {
  const dispatch = useAppDispatch();
  const isPresentationView = useAppSelector(classroomSelectors.selectIsPresentationView());
  const user = useUserProfileProperties(featuredPollResponse.user_id);
  const hideModal = () =>
    dispatch(hideFeaturedPollResponse({ pollResponseId: featuredPollResponse.id }));
  const isMobile = useIsMobile();

  ReactModal.setAppElement("#root");

  if (!user || !featuredPollResponse.response) return null;

  return (
    <ReactModal
      className="bg-white shadow-level-4 p7 absolute-center outline-none"
      overlayClassName="default-modal-overlay"
      parentSelector={() => document.querySelector(containerId)!}
      onRequestClose={hideModal}
      shouldCloseOnEsc={canControlClassroom}
      shouldCloseOnOverlayClick={false}
      isOpen
      shouldFocusAfterRender={false}
    >
      <div
        className="flex flex-auto"
        style={{
          maxHeight: containerHeight * 0.8 - 56, // 56 = 28 * 2 to account for padding (p7 = 28px)
          width: containerWidth * 0.8 - 56,
          maxWidth: isPresentationView ? "1600px" : "800px",
        }}
        data-testid="featured-poll-response-modal"
      >
        {canControlClassroom && !isPresentationView && (
          <IconButton onClick={hideModal} className="absolute top-0 right-0 mt3 mr3">
            <XCloseIcon size="lg" color="var(--black-tint-70)" />
          </IconButton>
        )}
        <LongFormPollResponse
          pollResponse={featuredPollResponse}
          user={user}
          canFeature={false}
          noMargin
          scroll
          isMobile={isMobile}
          isLast
        />
      </div>
    </ReactModal>
  );
}

export { FeaturedPollResponseModal };
